<script>
  /** @type {{ hidden?: boolean }} */
  let { hidden = false } = $props()
</script>

{#if !hidden}
  <div class="footer">
    <a href="/" class="footer-link">
      <svg class="footer-logo" viewBox="0 0 20 20" fill="currentColor">
        <path d="M10 2L2 7l8 5 8-5-8-5zM2 17l8 5 8-5M2 12l8 5 8-5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      Powered by AX Hub
    </a>
  </div>
{/if}

<style>
  .footer {
    text-align: center;
    margin-top: 40px;
    padding-top: 24px;
  }

  .footer-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: var(--footer-text);
    text-decoration: none;
    font-weight: 500;
    transition: opacity 150ms ease;
  }

  .footer-link:hover {
    opacity: 0.7;
  }

  .footer-logo {
    width: 14px;
    height: 14px;
  }
</style>
